import { render, staticRenderFns } from "./StatusAdditionalSigners.vue?vue&type=template&id=9be939a8&scoped=true&"
import script from "./StatusAdditionalSigners.vue?vue&type=script&lang=ts&"
export * from "./StatusAdditionalSigners.vue?vue&type=script&lang=ts&"
import style0 from "./StatusAdditionalSigners.vue?vue&type=style&index=0&id=9be939a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be939a8",
  null
  
)

export default component.exports